// Localized URL slugs for the Oversikt page: /:lang/:country/:city/:category
// e.g. /no/norge/bodo/spisesteder or /en/norway/bodo/restaurants.
// Kept as static maps (not stored per-doc in Firestore) since these are UI
// concerns, not data — only `countryCode` (ISO 3166-1 alpha-2) lives on the
// city doc itself.
import { slugify } from "../utils/slug";

export { slugify };

export const COUNTRY_SLUGS = {
  NO: { no: "norge", en: "norway" },
  NL: { no: "nederland", en: "netherlands" },
  FR: { no: "frankrike", en: "france" },
  ES: { no: "spania", en: "spain" },
  IT: { no: "italia", en: "italy" },
  TR: { no: "turkia", en: "turkey" },
  GB: { no: "storbritannia", en: "united-kingdom" },
  US: { no: "usa", en: "usa" },
};

export const CATEGORY_SLUGS = {
  restaurants: { no: "spisesteder", en: "restaurants" },
  activities: { no: "aktiviteter", en: "activities" },
  events: { no: "arrangementer", en: "events" },
};

export function countrySlug(countryCode, lang) {
  return COUNTRY_SLUGS[countryCode]?.[lang] || null;
}

export function categorySlug(category, lang) {
  return CATEGORY_SLUGS[category]?.[lang] || category;
}

export function countryCodeFromSlug(slug, lang) {
  const entry = Object.entries(COUNTRY_SLUGS).find(([, byLang]) => byLang[lang] === slug);
  return entry ? entry[0] : null;
}

export function categoryFromSlug(slug, lang) {
  const entry = Object.entries(CATEGORY_SLUGS).find(([, byLang]) => byLang[lang] === slug);
  return entry ? entry[0] : null;
}

// Builds the pretty path for a city that has a real `cities` doc with a
// known countryCode. Returns null if it can't (no country mapping yet) —
// callers fall back to the legacy ?city=/&lat=&lng= route in that case.
export function buildOversiktPath({ lang, city, category }) {
  const cSlug = countrySlug(city.countryCode, lang);
  if (!cSlug) return null;
  return `/${lang}/${cSlug}/${slugify(city.name)}/${categorySlug(category, lang)}`;
}

// Same, plus a 5th segment identifying one place — /no/norge/bodo/spisesteder/tiger-streetfood.
// Uses the location's permanent `slug` field (backfilled once, stable
// across name changes) rather than re-slugifying the name live.
export function buildPlacePath({ lang, city, category, location }) {
  const base = buildOversiktPath({ lang, city, category });
  if (!base || !location?.slug) return null;
  return `${base}/${location.slug}`;
}
